import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function ChildrenMinistryPage() {
  return (
    <div className="main-content" style={{ maxWidth: 900, margin: "0 auto", padding: 24 }}>
      <EditableText id="children-ministry.title" defaultContent="儿童/学生事工" defaultStyle={PAGE_TITLE_STYLE} />
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="children-ministry.body"
          defaultContent={"生命河教会儿童/学生事工：在主日和周五的团契，通过教导儿童赞美诗歌和儿童《圣经》来帮助儿童认识上帝。\n在未来希望通过向日葵学校的开办来从各方面帮助孩子成长。"}
          defaultStyle={BODY_STYLE}
        />
      </section>
      <PageCopyright pageId="children-ministry" />
    </div>
  );
}

export default ChildrenMinistryPage;
